/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InventoryQualityDTO interface.
 */
export function instanceOfInventoryQualityDTO(value) {
    return true;
}
export function InventoryQualityDTOFromJSON(json) {
    return InventoryQualityDTOFromJSONTyped(json, false);
}
export function InventoryQualityDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'flag': json['flag'] == null ? undefined : json['flag'],
        'totalProducts': json['totalProducts'] == null ? undefined : json['totalProducts'],
        'activeProducts': json['activeProducts'] == null ? undefined : json['activeProducts'],
        'buyBoxCount': json['buyBoxCount'] == null ? undefined : json['buyBoxCount'],
        'lowestCount': json['lowestCount'] == null ? undefined : json['lowestCount'],
        'inactiveProducts': json['inactiveProducts'] == null ? undefined : json['inactiveProducts'],
        'buyBoxPercentage': json['buyBoxPercentage'] == null ? undefined : json['buyBoxPercentage'],
        'lowestPricePercentage': json['lowestPricePercentage'] == null ? undefined : json['lowestPricePercentage'],
        'bsrProductCount': json['bsrProductCount'] == null ? undefined : json['bsrProductCount'],
        'bsrProductPercentage': json['bsrProductPercentage'] == null ? undefined : json['bsrProductPercentage'],
        'singleSellerProductCount': json['singleSellerProductCount'] == null ? undefined : json['singleSellerProductCount'],
        'singleSellerProductPercentage': json['singleSellerProductPercentage'] == null ? undefined : json['singleSellerProductPercentage'],
        'weeklyLoadedProductCount': json['weeklyLoadedProductCount'] == null ? undefined : json['weeklyLoadedProductCount'],
        'avgProfitMargin': json['avgProfitMargin'] == null ? undefined : json['avgProfitMargin'],
        'qualityScore': json['qualityScore'] == null ? undefined : json['qualityScore'],
        'lastSyncDate': json['lastSyncDate'] == null ? undefined : (new Date(json['lastSyncDate'])),
        'accountStatus': json['accountStatus'] == null ? undefined : json['accountStatus'],
        'onVacation': json['onVacation'] == null ? undefined : json['onVacation'],
    };
}
export function InventoryQualityDTOToJSON(json) {
    return InventoryQualityDTOToJSONTyped(json, false);
}
export function InventoryQualityDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'flag': value['flag'],
        'totalProducts': value['totalProducts'],
        'activeProducts': value['activeProducts'],
        'buyBoxCount': value['buyBoxCount'],
        'lowestCount': value['lowestCount'],
        'inactiveProducts': value['inactiveProducts'],
        'buyBoxPercentage': value['buyBoxPercentage'],
        'lowestPricePercentage': value['lowestPricePercentage'],
        'bsrProductCount': value['bsrProductCount'],
        'bsrProductPercentage': value['bsrProductPercentage'],
        'singleSellerProductCount': value['singleSellerProductCount'],
        'singleSellerProductPercentage': value['singleSellerProductPercentage'],
        'weeklyLoadedProductCount': value['weeklyLoadedProductCount'],
        'avgProfitMargin': value['avgProfitMargin'],
        'qualityScore': value['qualityScore'],
        'lastSyncDate': value['lastSyncDate'] == null ? undefined : ((value['lastSyncDate']).toISOString()),
        'accountStatus': value['accountStatus'],
        'onVacation': value['onVacation'],
    };
}
